import {Segment} from "@/types/Segments";
import {Scan} from "@/types/Scan";
import React from "react";
import {useTranslations} from "use-intl";
import useWalkStatus from "@/utils/hooks/useWalkStatus";

type WalkActionsProps = {
  segments?: Array<Segment>
  action?: string
  qrCode?: false | Scan[]
}

export default function WalkActions(props: WalkActionsProps) {
  const t = useTranslations("Walk")
  const walkStatus = useWalkStatus()

  const {action, segments, qrCode} = props

  const pid = walkStatus?.paths?.filter((itm) => {
    return itm.current
  }).at(0)?.path_id.toString()
  const currentSegment = walkStatus?.last_user_action?.segment_id

  if (!qrCode) return

  const filtered = pid && currentSegment ? qrCode.filter((item: Scan) => {
    return String(item.segment_id) === String(currentSegment) && String(item.path_id) === String(pid)
  }) : qrCode

  if (action !== 'start-end') {
    const actionFromQr = filtered.find((scan: Scan) => {
      return scan.type === action
    })

    const segment = segments?.find((segment: Segment) => {
      return String(segment.id) === String(actionFromQr?.segment_id)
    })

    if (segment) {
      return <p>{t('Segment')}: <strong>{segment?.name}</strong></p>
    }
  } else {
    return <>{segments && segments.map((segment: Segment, key: number) => {
      return <p key={key}>{t('Segment')}: <strong>{segment?.name}</strong></p>
    })}</>
  }
}
